import { render } from "./ParSous_Entite.vue?vue&type=template&id=51491f56"
import script from "./ParSous_Entite.vue?vue&type=script&lang=js"
export * from "./ParSous_Entite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__